








import { Component, Vue } from "vue-property-decorator";
import AuthTab,{AuthTabItem} from "@/containers/AuthTab.vue";

@Component({
  components: {
    AuthTab
  }
})
export default class TabFrame extends Vue {
  building = null;
  groups = [];

  tabItems: AuthTabItem[] = [
    {
      name: "users-list",
      title: "ユーザーリスト",
      scopes: ["company.management"]
    },
    {
      name: "users-new",
      title: "新規登録",
      scopes: ["company.management"]
    }
  ]
}
